export function getLedPriceExt(value) {
    this.generatedSku = value;

    if (!this.generatedSku) {
        return;
    }

    axios.get('/api/plannings/get_led_price', {params: {'sku': this.generatedSku}})
        .then(response => {
            this.calculatedProductPrice = response.data;

            // if calculatedProductPrice is empty or false, disable continue button

            if (!this.calculatedProductPrice) {
                this.validatedSteps = this.validatedSteps.filter(el => el !== 1);
            } else if (this.allLuminaireSelectionStepsSelected) {
                this.validatedSteps.push(1)
            }

        }).catch(error => {
            console.log(error);
            this.loading = false;
        });
}
